"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResolverContract = getResolverContract;
exports.getReverseRegistrarContract = getReverseRegistrarContract;
exports.getSIDContract = getSIDContract;
var _ethers = require("ethers");
var _SID = _interopRequireDefault(require("@siddomains/sid-contracts/build/contracts/SID.json"));
var _Resolver = _interopRequireDefault(require("@siddomains/sid-contracts/build/contracts/Resolver.json"));
var _ReverseRegistrar = _interopRequireDefault(require("@siddomains/sid-contracts/build/contracts/ReverseRegistrar.json"));
function getResolverContract(_ref) {
  var address = _ref.address,
    provider = _ref.provider;
  return new _ethers.Contract(address, _Resolver["default"], provider);
}
function getSIDContract(_ref2) {
  var address = _ref2.address,
    provider = _ref2.provider;
  return new _ethers.Contract(address, _SID["default"], provider);
}
function getReverseRegistrarContract(_ref3) {
  var address = _ref3.address,
    provider = _ref3.provider;
  return new _ethers.Contract(address, _ReverseRegistrar["default"], provider);
}